import LotesLista from "@/pages/lotes/LotesLista";

export default [
  {
    path: "/catalogo/lotes",
    name: "LotesLista",
    component: LotesLista,
    meta: { permissao: "lotes_acessar" },
  },
];
